import { render, staticRenderFns } from "./MarketProfileLayout.vue?vue&type=template&id=77e74a8e"
import script from "./MarketProfileLayout.vue?vue&type=script&lang=js"
export * from "./MarketProfileLayout.vue?vue&type=script&lang=js"
import style0 from "./MarketProfileLayout.vue?vue&type=style&index=0&id=77e74a8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports